import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Notification from '../_shared/dialog/notification'

function withNotify(WrappedComponent) {
    class Base extends Component {
        state = {
            erro: null,
            errors: []
        };

        notify = {
            error: (message, response) => {
                this.state.errors.push({ severity: "error", msg: response?.showErrorModal ? response.text : message ? message : 'Some error happened during the process', modal: !!response?.showErrorModal });
                this.setState({ ...this.state, errors: this.state.errors });
            },

            success: (message, response) => {
                this.state.errors.push({ severity: "success", msg: response?.showErrorModal ? response.text : message ? message : 'Your request was successfully submitted', modal: !!response?.showErrorModal });
                this.setState({ ...this.state, errors: this.state.errors });
            }
        }

        dispatchAction = (dispatch, action, callback, onError) => {
            dispatch(action())
                .then(response => {
                    if (response.showErrorModal)
                        return this.notify.errorModal(response.text);

                    if (callback)
                        callback(response);
                })
                .catch((err) => {
                    if (onError)
                        onError(err);
                })
        };

        render() {
            return (
                <>
                    {
                        this.state.errors.map((error, index) => (
                            <Notification erro={error} key={index} />
                        ))
                    }
                    <WrappedComponent {...this.props} notify={this.notify} dispatchAction={this.dispatchAction} />
                </>
            )
        }
    }

    function mapStateToProps(state) {
        return {
            //   var: state...,
        };
    }
    function mapDispatchToProps(dispatch) {
        return {
            ...bindActionCreators(dispatch),
        };
    }
    return connect(mapStateToProps, mapDispatchToProps)(Base);
}
export default withNotify;
